export default __webpack_public_path__ + "static/article-home-renovation-loan-tips-0fcb7a3e4dc9d5106470b64615bfad17.jpg";